var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Modale',{staticClass:"c-export-list",attrs:{"titre":_vm.$t('export_list_titre_matieres'),"picto":"Download2"}},[_c('p',{staticClass:"zone_credits"},[_vm._v(_vm._s(_vm.$t('telechargement_modal_remerciement_matiere')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }